import React from 'react';
import LandingpageLayout from '../../templates/LandingpageLayout';
import LandingContent from '../../organisms/LandingContent';

const LandingPage = ({...props}) => {
	return (
		<LandingpageLayout 
			renderContent={()=>{
				return(
					<LandingContent {...props}/>
				);
			}}
		/>
	);
};

LandingPage.propTypes = {
};

export default LandingPage;